/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var links = document.querySelectorAll('.nav-bar__item > .nav-dropdown > .nav-dropdown__item');
function childDropdownStyles() {
  var element = this,
    parentDropdownListHeight = element.closest('.nav-dropdown').clientHeight,
    childDropdownList = element.querySelector('.nav-dropdown '),
    topPos = element.offsetTop + 5,
    icon = element.querySelector('.nav-dropdown > .icon ');
  childDropdownList.style.cssText = 'min-height:' + parentDropdownListHeight + 'px;';
  icon.style.cssText = 'top:' + topPos + 'px;';
}
for (var i = 0; i < links.length; i++) {
  var link = links[i];
  link.addEventListener("mouseenter", childDropdownStyles);
}

document.addEventListener('DOMContentLoaded', function() {
  var mainWidget = document.querySelector('#stamped-main-widget');
  if (mainWidget != null && mainWidget != undefined) {
    var reviewHeader = mainWidget.querySelectorAll('.stamped-review-header');
    if (reviewHeader) {
      reviewHeader.forEach(function(item) {
        var author = item.querySelector('.author');
        var created = item.querySelector('.created');
        var authorWrap = document.createElement('div');

        authorWrap.classList.add('author-wrap');
        authorWrap.appendChild(author);
        authorWrap.appendChild(created);
        item.appendChild(authorWrap);
      });
    }
    var stampedSummaryText = mainWidget.querySelector('.stamped-summary-text');
    if (stampedSummaryText) {
      stampedSummaryText.innerHTML = stampedSummaryText.innerHTML.replace(/Based on/g, '');
    }
  }
});

jQuery('.product-gallery__carousel-item .pimage-lightbox').fancybox({
  loop: true,
  btnTpl: {
    arrowLeft: '<button data-fancybox-prev="" class="fancybox-button fancybox-button--arrow_left" title="Previous"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="-10 -10 44.5 62.03"><path d="M5 .6a2 2 0 0 0-3 0L1 1.8a2 2 0 0 0 0 2.8l14.6 14.7a2 2 0 0 1 0 2.8L.6 37a2 2 0 0 0 0 3L2 41.3a2 2 0 0 0 3 0l19-19a2 2 0 0 0 0-2.8z"></path></svg></div></button>',

    arrowRight: '<button data-fancybox-next="" class="fancybox-button fancybox-button--arrow_right" title="Next"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="-10 -10 44.5 62.03"><path d="M5 .6a2 2 0 0 0-3 0L1 1.8a2 2 0 0 0 0 2.8l14.6 14.7a2 2 0 0 1 0 2.8L.6 37a2 2 0 0 0 0 3L2 41.3a2 2 0 0 0 3 0l19-19a2 2 0 0 0 0-2.8z"></path></svg></div></button>'
  }
});

jQuery('.product-gallery__carousel .gallery-zoom-icon').click(function() {
  jQuery('.product-gallery__carousel-item.is-selected .pimage-lightbox').trigger('click');

});

window.addEventListener('load', function() {
  document.querySelectorAll('.cat-menu__control').forEach(control => {
    let rightId = '#' + control.getAttribute('aria-controls');

    control.addEventListener('mouseover', function() {
      if (!document.querySelector(rightId)) return;
      console.log(rightId)
      console.log(document.querySelector(rightId))
      document.querySelector('.cat-menu__right .cat-menu__list-container[aria-hidden="false"]').setAttribute('aria-hidden', true);

      document.querySelector(rightId).setAttribute('aria-hidden', false);
    });
  });

  document.querySelectorAll('.brand-menu__control').forEach(control => {
    let rightId = '#' + control.getAttribute('aria-controls');

    control.addEventListener('mouseover', function() {
      if (!document.querySelector(rightId)) return;
      console.log(rightId)
      console.log(document.querySelector(rightId))
      document.querySelector('.brand-menu__right .brand-menu__list-container[aria-hidden="false"]').setAttribute('aria-hidden', true);

      document.querySelector(rightId).setAttribute('aria-hidden', false);
    });
  });

  document.querySelectorAll('.scroller').forEach(scroller => {
    const [prevButton, nextButton] = Array.from(scroller.querySelectorAll('.flickity-button'));
    if (!prevButton && !nextButton) return

    const scrollInner = scroller.querySelector('.scroller__inner')

    prevButton.addEventListener('click', e => {
      e.preventDefault();
      const cardSize = scroller.querySelector('.scroller__item').clientWidth;

      scrollInner.scrollTo({
        left: scrollInner.scrollLeft - cardSize,
        behavior: 'smooth'
      });
    })
    nextButton.addEventListener('click', e => {
      e.preventDefault();
      const cardSize = scroller.querySelector('.scroller__item').clientWidth;

      scrollInner.scrollTo({
        left: scrollInner.scrollLeft + cardSize,
        behavior: 'smooth'
      });
    })
  });

  document.querySelectorAll('.product-form__option').forEach(option => {
    const swatchList = option.querySelector('.variant-swatch-list') || option.querySelector('.block-swatch-list')

    if (!swatchList) { return }

    const title = option.querySelector('.product-form__option-name')
    const titleValue = title.querySelector('.product-form__option-option-value')
    const selectedValue = option.querySelector('select.product-form__single-selector')

    title.addEventListener('click', (e) => {
      if (window.innerWidth > 767) return
      swatchList.ariaExpanded = !JSON.parse(swatchList.ariaExpanded)
    })

    let swatches = swatchList.querySelectorAll('.variant-swatch');

    if (swatches.length === 0) {
      swatches = swatchList.querySelectorAll('.block-swatch');
    }

    if (!swatches || swatches.length === 0) return

    swatches.forEach(swatch => {
      const item = swatch.querySelector('.variant-swatch__item') || swatch.querySelector('.block-swatch__item')
      item?.addEventListener('click', e => {
        if (selectedValue && selectedValue.value !== swatch.querySelector('input').value) {
          selectedValue.value = swatch.querySelector('input').value
        }

        if (titleValue) {
          titleValue.textContent = swatch.querySelector('input').value
        }

        if (window.innerWidth > 767) {
          // timeout 250ms then scroll to top
          setTimeout(() => {
            window.scrollTo(0, 0)
          }, 100);

          return
        }

        const inputState = swatch.querySelector('input').checked
        const expanded = JSON.parse(swatchList.ariaExpanded)

        if (expanded || (inputState && !expanded)) {
          swatchList.ariaExpanded = !expanded

          if (expanded) {
            setTimeout(() => {
              swatchList.scrollTop = 0
            }, 150);
          }
          return
        }
      })
    })

    selectedValue?.addEventListener('change', () => {
      const targetSwatch = swatchList.querySelector(`input[value="${selectedValue.value}"]`)
      if (targetSwatch.checked === true) return

      targetSwatch.checked = true
    })
  })
});
